// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"79":"e6e97504","512":"50da287f"}[chunkId] + ".chunk.css";
};